<template>
  <ol class="breadcrumb">
    <li
      v-for="(routeObject, index) in routeRecords"
      :key="index"
      class="breadcrumb-item">
      <span
        v-if="isLast(index)"
        class="active">{{ getName(routeObject) }}</span>
      <router-link
        v-else
        :to="routeObject">{{ getName(routeObject) }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    routeRecords: function() {
      return this.list.filter(route => route.name || route.meta.label);
    }
  },
  methods: {
    getName(item) {
      return item.meta && item.meta.label ? item.meta.label : item.name || null;
    },
    isLast(index) {
      return index === this.list.length - 1;
    }
  }
};
</script>
